"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'route.whatsapp.group': 'Grupa WhatsApp',
    'route.whatsapp.group.create': 'Dodaj grupę WhatsApp',
    'route.whatsapp.dm': 'WhatsApp Kontakt DM',
};
